import React, { useState, useEffect, useContext } from "react";
import APIServicenew from "../utils/APIGeneralService";
import { UserContext } from "../context/UserContextProvider";
import { useNavigate, Link } from "react-router-dom";
import { formatDateTime } from "../utils/Helper";
import PaginatedTable from "../components/Table/PaginatedTable";
import Form from 'react-bootstrap/Form';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SlEye } from "react-icons/sl";

const MasterTestFolder = () => {
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const { accessToken, logout } = useContext(UserContext);
  const navigate = useNavigate();

  // ================= Fixed Modality Data =================
  const defaultModalityData = [
    { modality: "US", id: 1 },
    { modality: "CT", id: 2 },
    { modality: "MRI", id: 3 },
    { modality: "Pregnancy", id: 4 },
    { modality: "Injection/Biopsy", id: 5 },
    { modality: "BMD/DEXA", id: 6 },
    { modality: "CBCT", id: 7 }
  ];

  // ================= State =================
  const [folders, setFolders] = useState([]);
  const [loadingFolders, setLoadingFolders] = useState(false);
  const [currentFolderPage, setCurrentFolderPage] = useState(1);
  const [folderLimit, setFolderLimit] = useState(5);
  const [totalFolderCount, setTotalFolderCount] = useState(0);
  const [folderKeyword, setFolderKeyword] = useState("");
  const [testCases, setTestCases] = useState([]);
  const [loadingTestCases, setLoadingTestCases] = useState(false);
  const [currentTestCasePage, setCurrentTestCasePage] = useState(1);
  const [testCaseLimit, setTestCaseLimit] = useState(5);
  const [totalTestCaseCount, setTotalTestCaseCount] = useState(0);
  const [testCaseKeyword, setTestCaseKeyword] = useState("");
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [showTestCaseModal, setShowTestCaseModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingFolderId, setEditingFolderId] = useState(null);
  const [isActiveFilter, setIsActiveFilter] = useState(true);

  // Separate hierarchy states for each modal
  const [folderHierarchy, setFolderHierarchy] = useState({});
  const [testCaseHierarchy, setTestCaseHierarchy] = useState({});
  const [allFolders, setAllFolders] = useState([]);
  const [loadingAllFolders, setLoadingAllFolders] = useState(false);
  const [testListSelectedModality, setTestListSelectedModality] = useState(null);
  // Add to your state declarations
  const [showTestListModal, setShowTestListModal] = useState(false);
  const [selectedTestListModality, setSelectedTestListModality] = useState(null);
  const [testListModalHierarchy, setTestListModalHierarchy] = useState({});

  // ================= Test List Hierarchy State =================
  const [testListHierarchy, setTestListHierarchy] = useState({});
  const [testListLoading, setTestListLoading] = useState(false);
  const [modalityCounts, setModalityCounts] = useState({});
  const [loadingModalityCounts, setLoadingModalityCounts] = useState(false);
  const [foldersWithTestCases, setFoldersWithTestCases] = useState({});
  // Add these to your state declarations
  const [folderPaginationData, setFolderPaginationData] = useState({
    total: 0,
    page: 1,
    page_size: 5,
    total_pages: 0
  });
  const [testCasePaginationData, setTestCasePaginationData] = useState({
    total: 0,
    page: 1,
    page_size: 5,
    total_pages: 0
  });


  const [newFolder, setNewFolder] = useState({
    folder_name: "",
    description: "",
  });

  const [newTestCase, setNewTestCase] = useState({
    master_test_folder: "",
  });

  const [expandedFolders, setExpandedFolders] = useState({});
  const [selectedTests, setSelectedTests] = useState({});

  const [showAllModalities, setShowAllModalities] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  // ================= Initialize Hierarchy Function =================
  const initializeHierarchy = () => {
    const initialHierarchy = {};
    defaultModalityData.forEach((mod, index) => {
      initialHierarchy[mod.id] = {
        modality: mod.modality,
        selected: false,
        sections: {}
      };
    });
    return initialHierarchy;
  };

  // ================= Fetch Functions =================
  const fetchFolders = async (page = 1, activeOverride = isActiveFilter) => {
    setLoadingFolders(true);
    try {
      const skip = (page - 1) * folderLimit;
      const queryParams = [
        `limit=${folderLimit}`,
        `page=${page}`,
        `is_active=${activeOverride}`
      ];

      if (folderKeyword) {
        queryParams.push(`keyword=${encodeURIComponent(folderKeyword)}`);
      }

      const queryString = `?${queryParams.join("&")}`;
      const response = await APIServices.get(`admin/folders${queryString}`, headers);

      if (response?.status === 200) {
        const data = response?.data?.data || [];
        setFolders(data);

        // Store pagination data
        if (response.data) {
          setFolderPaginationData({
            total: response.data.total || 0,
            page: response.data.page || 1,
            page_size: response.data.page_size || folderLimit,
            total_pages: response.data.total_pages || 1
          });
        }

        // Update total pages for PaginatedTable
        const totalPages = response?.data?.total_pages || 1;
        setTotalFolderCount(totalPages);

        const initialSelected = {};
        data.forEach(folder => {
          initialSelected[folder.folder_id] = [];
        });
        setSelectedTests(initialSelected);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setFolders([]);
        setTotalFolderCount(0);
        setFolderPaginationData({
          total: 0,
          page: 1,
          page_size: folderLimit,
          total_pages: 0
        });
      }
    } catch (error) {
      console.error("Error fetching folders:", error);
      setFolders([]);
      setTotalFolderCount(0);
      setFolderPaginationData({
        total: 0,
        page: 1,
        page_size: folderLimit,
        total_pages: 0
      });
    }
    setLoadingFolders(false);
  };
  const fetchModalityCounts = async () => {
    setLoadingModalityCounts(true);
    try {
      const response = await APIServices.get(
        "/test-execution/modality-count",
        headers
      );

      if (response?.status === 200) {
        const countsData = response.data || [];
        const countsMap = {};
        let totalCount = 0
        countsData.forEach(item => {
          countsMap[item.modality] = item.count;
          totalCount = totalCount + item.count;
        });
        setTotalCount(totalCount)
        setModalityCounts(countsMap);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      }
    } catch (error) {
      console.error("Error fetching modality counts:", error);
      setModalityCounts({});
    } finally {
      setLoadingModalityCounts(false);
    }
  };

  // Add this useEffect to fetch counts when component mounts (around line 600)
  useEffect(() => {
    fetchModalityCounts();
  }, []);

  const fetchAllFoldersForTestCase = async () => {
    setLoadingAllFolders(true);
    try {
      const response = await APIServices.get(
        `admin/folders?limit=10000&page=1&is_active=true`,
        headers
      );

      if (response?.status === 200) {
        const foldersData = response?.data?.data || [];
        setAllFolders(foldersData);

        // Store folders with their test cases
        const foldersMap = {};
        foldersData.forEach(folder => {
          foldersMap[folder.folder_id] = folder;
        });
        setFoldersWithTestCases(prev => ({ ...prev, ...foldersMap }));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setAllFolders([]);
      }
    } catch (error) {
      console.error("Error fetching all folders:", error);
      setAllFolders([]);
    }
    setLoadingAllFolders(false);
  };



  const fetchTestCases = async (page = 1) => {
    setLoadingTestCases(true);
    try {
      const skip = (page - 1) * testCaseLimit;
      const queryParams = [`limit=${testCaseLimit}`, `page=${skip}`];
      if (testCaseKeyword) queryParams.push(`keyword=${encodeURIComponent(testCaseKeyword)}`);
      const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
      const response = await APIServices.get(`admin/test-cases${queryString}`, headers);

      if (response?.status === 200) {
        const data = response?.data?.data || []; // Updated: Use 'data' array
        setTestCases(data);

        // Store pagination data
        if (response.data) {
          setTestCasePaginationData({
            total: response.data.total || 0,
            page: response.data.page || 1,
            page_size: response.data.page_size || testCaseLimit,
            total_pages: response.data.total_pages || 1
          });
        }

        const totalPages = response?.data?.total_pages || 1;
        setTotalTestCaseCount(totalPages);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setTestCases([]);
        setTotalTestCaseCount(0);
        setTestCasePaginationData({
          total: 0,
          page: 1,
          page_size: testCaseLimit,
          total_pages: 0
        });
      }
    } catch (error) {
      console.error("Error fetching test cases:", error);
      setTestCases([]);
      setTotalTestCaseCount(0);
      setTestCasePaginationData({
        total: 0,
        page: 1,
        page_size: testCaseLimit,
        total_pages: 0
      });
    }
    setLoadingTestCases(false);
  };

  // Delete a folder
  const deleteFolder = async (folderId) => {
    if (!window.confirm("Are you sure you want to delete this folder?")) return;

    try {
      const response = await APIServices.post(
        "/test-execution/mark-folder-status",
        {
          folder_id: folderId,
          is_active: false
        },
        headers
      );

      if (response?.status === 200) {
        toast.success("Folder deleted successfully");
        fetchFolders(currentFolderPage);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        toast.error(response?.data?.detail ? response?.data?.detail : "Failed to delete folder");
      }
    } catch (error) {
      console.error("Error deleting folder:", error);
      toast.error("Failed to delete folder");
    }
  };

  // Restore a folder (set is_active to true)
  const restoreFolder = async (folderId) => {
    if (!window.confirm("Are you sure you want to restore this folder?")) return;

    try {
      const response = await APIServices.post(
        "/test-execution/mark-folder-status",
        {
          folder_id: folderId,
          is_active: true
        },
        headers
      );

      if (response?.status === 200) {
        toast.success("Folder restored successfully");
        fetchFolders(currentFolderPage);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        toast.error(response?.data?.detail ? response?.data?.detail : "Failed to restore folder");

      }
    } catch (error) {
      console.error("Error restoring folder:", error);
      toast.error("Failed to restore folder");
    }
  };

  // Delete a test case
  const deleteTestCase = async (testCaseId) => {
    if (!window.confirm("Are you sure you want to delete this test case?")) return;
    try {
      const response = await APIServices.delete(`admin/test-cases/${testCaseId}`, headers);
      if (response?.status === 200) {
        toast.success("Test case deleted successfully!");
        fetchTestCases(currentTestCasePage);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        toast.error(response?.data?.detail ? response?.data?.detail : "Failed to delete test case");

      }
    } catch (error) {
      console.error("Error deleting test case:", error);
      toast.error("Error deleting test case");
    }
  };

  // ================= Folder Hierarchy Functions =================
  const fetchSectionsForFolderModality = async (modalityId, modalityName) => {
    try {
      const response = await APIServices.get(`admin/sections-by-modality?modality=${modalityName}`, headers);
      if (response?.status === 200) {
        const sectionsData = response.data || [];

        setFolderHierarchy(prev => {
          const updatedHierarchy = { ...prev };
          const sectionsObj = {};

          sectionsData.forEach(section => {
            sectionsObj[section.id] = {
              section_name: section.section_name,
              selected: false,
              bodyParts: {},
              loaded: true
            };
          });

          updatedHierarchy[modalityId] = {
            ...updatedHierarchy[modalityId],
            sections: sectionsObj,
            sectionsLoaded: true
          };

          return updatedHierarchy;
        });
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      }
    } catch (error) {
      console.error(`Error fetching sections for ${modalityName}:`, error);
      setFolderHierarchy(prev => ({
        ...prev,
        [modalityId]: {
          ...prev[modalityId],
          sectionsLoaded: true
        }
      }));
    }
  };

  const fetchBodyPartsForFolderSection = async (modalityId, sectionId, modalityName) => {
    try {
      const response = await APIServices.get(
        `admin/bodyparts-by-section?modality=${modalityName}&section_id=${sectionId}`,
        headers
      );

      if (response?.status === 200) {
        const bodyPartsData = response.data || [];

        setFolderHierarchy(prev => {
          const updatedHierarchy = { ...prev };
          const bodyPartsObj = {};

          bodyPartsData.forEach(bodyPart => {
            bodyPartsObj[bodyPart.id] = {
              body_part_name: bodyPart.body_part_name,
              selected: false
            };
          });

          updatedHierarchy[modalityId].sections[sectionId] = {
            ...updatedHierarchy[modalityId].sections[sectionId],
            bodyParts: bodyPartsObj,
            bodyPartsLoaded: true
          };

          return updatedHierarchy;
        });
      }
    } catch (error) {
      console.error(`Error fetching body parts for ${modalityName}, section ${sectionId}:`, error);
      setFolderHierarchy(prev => {
        const updatedHierarchy = { ...prev };
        updatedHierarchy[modalityId].sections[sectionId] = {
          ...updatedHierarchy[modalityId].sections[sectionId],
          bodyPartsLoaded: true
        };
        return updatedHierarchy;
      });
    }
  };

  const handleFolderModalityCheck = async (modalityId, checked) => {
    setFolderHierarchy(prev => {
      const updatedHierarchy = { ...prev };
      updatedHierarchy[modalityId] = {
        ...updatedHierarchy[modalityId],
        selected: checked
      };

      if (checked && !updatedHierarchy[modalityId].sectionsLoaded) {
        fetchSectionsForFolderModality(modalityId, updatedHierarchy[modalityId].modality);
      }

      return updatedHierarchy;
    });
  };

  const handleFolderSectionCheck = async (modalityId, sectionId, checked) => {
    setFolderHierarchy(prev => {
      const updatedHierarchy = { ...prev };
      updatedHierarchy[modalityId].sections[sectionId] = {
        ...updatedHierarchy[modalityId].sections[sectionId],
        selected: checked
      };

      if (checked && !updatedHierarchy[modalityId].sections[sectionId].bodyPartsLoaded) {
        fetchBodyPartsForFolderSection(modalityId, sectionId, updatedHierarchy[modalityId].modality);
      }

      return updatedHierarchy;
    });
  };

  const handleFolderBodyPartCheck = (modalityId, sectionId, bodyPartId, checked) => {
    setFolderHierarchy(prev => {
      const updatedHierarchy = { ...prev };
      updatedHierarchy[modalityId].sections[sectionId].bodyParts[bodyPartId] = {
        ...updatedHierarchy[modalityId].sections[sectionId].bodyParts[bodyPartId],
        selected: checked
      };
      return updatedHierarchy;
    });
  };

  // ================= Test Case Hierarchy Functions =================
  const fetchSectionsForTestCaseModality = async (modalityId, modalityName, preselectedTestCases = []) => {
    try {
      const response = await APIServices.get(`admin/sections-by-modality?modality=${modalityName}`, headers);
      if (response?.status === 200) {
        const sectionsData = response.data || [];

        setTestCaseHierarchy(prev => {
          const updatedHierarchy = { ...prev };
          const sectionsObj = {};

          sectionsData.forEach(section => {
            sectionsObj[section.id] = {
              section_name: section.section_name,
              selected: false,
              bodyParts: {},
              loaded: true
            };
          });

          updatedHierarchy[modalityId] = {
            ...updatedHierarchy[modalityId],
            sections: sectionsObj,
            sectionsLoaded: true
          };

          return updatedHierarchy;
        });
      }
    } catch (error) {
      console.error(`Error fetching sections for ${modalityName}:`, error);
      setTestCaseHierarchy(prev => ({
        ...prev,
        [modalityId]: {
          ...prev[modalityId],
          sectionsLoaded: true
        }
      }));
    }
  };

  const fetchBodyPartsForTestCaseSection = async (modalityId, sectionId, modalityName) => {
    try {
      const response = await APIServices.get(
        `admin/bodyparts-by-section?modality=${modalityName}&section_id=${sectionId}`,
        headers
      );

      if (response?.status === 200) {
        const bodyPartsData = response.data || [];

        setTestCaseHierarchy(prev => {
          const updatedHierarchy = { ...prev };
          const bodyPartsObj = {};

          bodyPartsData.forEach(bodyPart => {
            bodyPartsObj[bodyPart.id] = {
              body_part_name: bodyPart.body_part_name,
              selected: false
            };
          });

          updatedHierarchy[modalityId].sections[sectionId] = {
            ...updatedHierarchy[modalityId].sections[sectionId],
            bodyParts: bodyPartsObj,
            bodyPartsLoaded: true
          };

          return updatedHierarchy;
        });
      }
    } catch (error) {
      console.error(`Error fetching body parts for ${modalityName}, section ${sectionId}:`, error);
      setTestCaseHierarchy(prev => {
        const updatedHierarchy = { ...prev };
        updatedHierarchy[modalityId].sections[sectionId] = {
          ...updatedHierarchy[modalityId].sections[sectionId],
          bodyPartsLoaded: true
        };
        return updatedHierarchy;
      });
    }
  };

  const handleTestCaseModalityCheck = async (modalityId, checked) => {
    setTestCaseHierarchy(prev => {
      const updatedHierarchy = { ...prev };
      updatedHierarchy[modalityId] = {
        ...updatedHierarchy[modalityId],
        selected: checked
      };

      if (checked && !updatedHierarchy[modalityId].sectionsLoaded) {
        // Get preselected test cases if a folder is selected
        const folderId = newTestCase.master_test_folder;
        const folderData = foldersWithTestCases[folderId];
        const preselectedTestCases = folderData?.added_testcases || [];

        fetchSectionsForTestCaseModality(
          modalityId,
          updatedHierarchy[modalityId].modality,
          preselectedTestCases
        );
      }

      return updatedHierarchy;
    });
  };

  // Update the handleTestCaseSectionCheck function
  const handleTestCaseSectionCheck = async (modalityId, sectionId, checked) => {
    setTestCaseHierarchy(prev => {
      const updatedHierarchy = { ...prev };
      updatedHierarchy[modalityId].sections[sectionId] = {
        ...updatedHierarchy[modalityId].sections[sectionId],
        selected: checked
      };

      if (checked && !updatedHierarchy[modalityId].sections[sectionId].bodyPartsLoaded) {
        // Get preselected test cases for this modality
        const folderId = newTestCase.master_test_folder;
        const folderData = foldersWithTestCases[folderId];
        const preselectedTestCases = folderData?.added_testcases || [];

        fetchBodyPartsForTestCaseSection(
          modalityId,
          sectionId,
          updatedHierarchy[modalityId].modality,
          preselectedTestCases
        );
      }

      return updatedHierarchy;
    });
  };



  const handleTestCaseBodyPartCheck = (modalityId, sectionId, bodyPartId, checked) => {
    setTestCaseHierarchy(prev => {
      const updatedHierarchy = { ...prev };
      updatedHierarchy[modalityId].sections[sectionId].bodyParts[bodyPartId] = {
        ...updatedHierarchy[modalityId].sections[sectionId].bodyParts[bodyPartId],
        selected: checked
      };
      return updatedHierarchy;
    });
  };

  // ================= Helper Functions =================
  const getSelectedTestCasesFromFolderHierarchy = () => {
    const test_cases = [];

    Object.keys(folderHierarchy).forEach(modalityId => {
      const modalityData = folderHierarchy[modalityId];
      const modalityName = modalityData.modality;

      Object.keys(modalityData.sections).forEach(sectionId => {
        const sectionData = modalityData.sections[sectionId];

        Object.keys(sectionData.bodyParts).forEach(bodyPartId => {
          const bodyPartData = sectionData.bodyParts[bodyPartId];

          if (bodyPartData.selected) {
            test_cases.push({
              modality: modalityName,
              section_id: parseInt(sectionId),
              body_part_id: parseInt(bodyPartId),
            });
          }
        });
      });
    });

    return test_cases;
  };

  const getSelectedTestCasesFromTestCaseHierarchy = () => {
    const test_cases = [];

    Object.keys(testCaseHierarchy).forEach(modalityId => {
      const modalityData = testCaseHierarchy[modalityId];
      const modalityName = modalityData.modality;

      Object.keys(modalityData.sections).forEach(sectionId => {
        const sectionData = modalityData.sections[sectionId];

        Object.keys(sectionData.bodyParts).forEach(bodyPartId => {
          const bodyPartData = sectionData.bodyParts[bodyPartId];

          if (bodyPartData.selected) {
            test_cases.push({
              modality: modalityName,
              section_id: parseInt(sectionId),
              body_part_id: parseInt(bodyPartId),
            });
          }
        });
      });
    });

    return test_cases;
  };

  // ================= Form Validation =================
  const validateFolder = () => {
    const newErrors = {};
    if (!newFolder.folder_name) newErrors.folder_name = "Folder name is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateTestCase = () => {
    if (!newTestCase.master_test_folder) {
      toast.error("Please select a folder");
      return false;
    }

    const selectedTestCases = getSelectedTestCasesFromTestCaseHierarchy();
    if (selectedTestCases.length === 0) {
      toast.error("Please select at least one body part");
      return false;
    }

    return true;
  };

  // ================= Folder CRUD Functions =================
  const createFolder = async () => {
    if (!validateFolder()) return;
    try {
      const test_cases = getSelectedTestCasesFromFolderHierarchy();

      const payload = {
        folder_name: newFolder.folder_name,
        test_cases,
      };

      const response = await APIServices.post(
        "admin/folders",
        payload,
        headers
      );

      if (response?.status === 201 || response?.status === 200) {
        toast.success("Folder created successfully");
        setNewFolder({ folder_name: "", description: "" });
        setFolderHierarchy(initializeHierarchy());
        setShowFolderModal(false);
        fetchFolders(currentFolderPage);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        console.log("response", response)
        toast.error(response?.data?.detail ? response?.data?.detail : "Failed to create folder");
      }
    } catch (error) {
      console.error("Failed to create folder:", error);
      toast.error("Failed to create folder");
    }
  };

  const updateFolder = async () => {
    if (!validateFolder()) return;

    try {
      const response = await APIServices.put(
        `test-execution/folders/${editingFolderId}`,
        {
          folder_name: newFolder.folder_name
        },
        headers
      );

      if (response?.status === 200) {
        setShowFolderModal(false);
        setIsEditMode(false);
        setEditingFolderId(null);
        setNewFolder({ folder_name: "", description: "" });
        fetchFolders(currentFolderPage);
        toast.success("Folder updated successfully!");
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        toast.error(response?.data?.detail ? response?.data?.detail : "Failed to update folder");

      }
    } catch (error) {
      console.error("Error updating folder:", error);
      toast.error("Failed to update folder");
    }
  };

  // ================= Test Case CRUD Functions =================
  const createTestCase = async () => {
    if (!validateTestCase()) return;

    try {
      const test_cases = getSelectedTestCasesFromTestCaseHierarchy();

      const payload = {
        folderId: newTestCase.master_test_folder,
        test_cases
      };

      const response = await APIServices.post(
        `admin/test-cases`,
        payload,
        headers
      );

      if (response?.status === 201 || response?.status === 200) {
        toast.success("Test case created successfully!");

        setNewTestCase({ master_test_folder: "" });
        setTestCaseHierarchy(initializeHierarchy());
        setShowTestCaseModal(false);
        fetchTestCases(currentTestCasePage);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        toast.error(response?.data?.detail ? response?.data?.detail : "Failed to create test case");

      }
    } catch (error) {
      console.error("Failed to create test case:", error);
      toast.error("Failed to create test case");
    }
  };

  // ================= Handlers =================
  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => ({ ...prev, [folderId]: !prev[folderId] }));
  };

  const handleTestSelection = (folderId, testId, checked) => {
    setSelectedTests(prev => {
      const currentSelected = prev[folderId] || [];
      let updatedSelected;
      if (checked) updatedSelected = [...currentSelected, testId];
      else updatedSelected = currentSelected.filter(id => id !== testId);
      return { ...prev, [folderId]: updatedSelected };
    });
  };

  const saveSelectedTests = async (folderId) => {
    try {
      const response = await APIServices.put(
        `admin/folders/${folderId}/tests`,
        { test_ids: selectedTests[folderId] || [] },
        headers
      );
      if (response?.status === 200) {
        toast.success("Tests saved successfully!");
        fetchFolders(currentFolderPage);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      }
    } catch (error) {
      console.error("Failed to save tests:", error);
      toast.error("Failed to save tests");
    }
  };

  const handleFolderInputChange = (e) => {
    setNewFolder({ ...newFolder, [e.target.name]: e.target.value });
  };

  const handleTestCaseInputChange = (e) => {
    const folderId = e.target.value;
    setNewTestCase({ ...newTestCase, [e.target.name]: folderId });

    // If a folder is selected, preselect its test cases
    if (folderId) {
      preselectTestCasesForFolder(folderId);
    } else {
      // If no folder selected, reset hierarchy
      setTestCaseHierarchy(initializeHierarchy());
    }
  };

  const preselectTestCasesForFolder = (folderId) => {
    const folderData = foldersWithTestCases[folderId];

    if (!folderData || !folderData.added_testcases || folderData.added_testcases.length === 0) {
      // No test cases to preselect, reset hierarchy
      setTestCaseHierarchy(initializeHierarchy());
      return;
    }

    const preselectedTestCases = folderData.added_testcases;

    // Initialize hierarchy
    const initialHierarchy = initializeHierarchy();

    // For each modality that has preselected test cases, mark it as selected
    const modalitiesToLoad = {};
    preselectedTestCases.forEach(test => {
      const modalityEntry = defaultModalityData.find(m => m.modality === test.modality);
      if (modalityEntry) {
        modalitiesToLoad[modalityEntry.id] = {
          modality: test.modality,
          sectionsLoaded: false
        };
      }
    });

    // Set initial hierarchy with modalities marked
    const updatedHierarchy = { ...initialHierarchy };
    Object.keys(modalitiesToLoad).forEach(modalityId => {
      if (updatedHierarchy[modalityId]) {
        updatedHierarchy[modalityId].selected = true;
      }
    });

    setTestCaseHierarchy(updatedHierarchy);

    // Load sections for each modality that has preselected test cases
    Object.keys(modalitiesToLoad).forEach(modalityId => {
      const modality = modalitiesToLoad[modalityId].modality;

      // Fetch sections for this modality and then preselect body parts
      fetchSectionsForTestCaseModalityWithPreselection(modalityId, modality, preselectedTestCases);
    });
  };


  const fetchSectionsForTestCaseModalityWithPreselection = async (modalityId, modalityName, preselectedTestCases) => {
    try {
      const response = await APIServices.get(`admin/sections-by-modality?modality=${modalityName}`, headers);
      if (response?.status === 200) {
        const sectionsData = response.data || [];

        setTestCaseHierarchy(prev => {
          const updatedHierarchy = { ...prev };
          const sectionsObj = {};

          sectionsData.forEach(section => {
            sectionsObj[section.id] = {
              section_name: section.section_name,
              selected: false,
              bodyParts: {},
              loaded: true
            };
          });

          updatedHierarchy[modalityId] = {
            ...updatedHierarchy[modalityId],
            sections: sectionsObj,
            sectionsLoaded: true
          };

          return updatedHierarchy;
        });

        // After setting sections, fetch body parts for each section that has preselected test cases
        sectionsData.forEach(section => {
          const hasPreselectedInSection = preselectedTestCases.some(
            test => test.modality === modalityName && test.section_id === section.id
          );

          if (hasPreselectedInSection) {
            fetchBodyPartsForTestCaseSectionWithPreselection(
              modalityId,
              section.id,
              modalityName,
              preselectedTestCases
            );
          }
        });
      }
    } catch (error) {
      console.error(`Error fetching sections for ${modalityName}:`, error);
    }
  };


  const fetchBodyPartsForTestCaseSectionWithPreselection = async (modalityId, sectionId, modalityName, preselectedTestCases) => {
    try {
      const response = await APIServices.get(
        `admin/bodyparts-by-section?modality=${modalityName}&section_id=${sectionId}`,
        headers
      );

      if (response?.status === 200) {
        const bodyPartsData = response.data || [];

        setTestCaseHierarchy(prev => {
          const updatedHierarchy = { ...prev };
          const bodyPartsObj = {};

          bodyPartsData.forEach(bodyPart => {
            // Check if this body part should be preselected
            const isPreselected = preselectedTestCases.some(
              test => test.modality === modalityName &&
                test.section_id === parseInt(sectionId) &&
                test.body_part_id === bodyPart.id
            );

            bodyPartsObj[bodyPart.id] = {
              body_part_name: bodyPart.body_part_name,
              selected: isPreselected
            };
          });

          updatedHierarchy[modalityId].sections[sectionId] = {
            ...updatedHierarchy[modalityId].sections[sectionId],
            bodyParts: bodyPartsObj,
            bodyPartsLoaded: true
          };

          // If any body part in this section is preselected, also preselect the section
          const anyBodyPartSelected = Object.values(bodyPartsObj).some(bp => bp.selected);
          if (anyBodyPartSelected) {
            updatedHierarchy[modalityId].sections[sectionId].selected = true;
          }

          return updatedHierarchy;
        });
      }
    } catch (error) {
      console.error(`Error fetching body parts for ${modalityName}, section ${sectionId}:`, error);
    }
  };


  const openTestCaseModal = () => {
    setTestCaseHierarchy(initializeHierarchy());
    fetchAllFoldersForTestCase();
    setShowTestCaseModal(true);
  };


  const openFolderModal = () => {
    setFolderHierarchy(initializeHierarchy());
    setShowFolderModal(true);
  };

  // ================= Hierarchy Components =================
  const FolderHierarchyComponent = () => (
    <div className="body_sec white_box rounded p-3">
      <h6 className="font_14 font-500 clr_blue mb-3">
        Select Sections and Body Parts
      </h6>

      {Object.keys(folderHierarchy).map(modalityId => {
        const modalityData = folderHierarchy[modalityId];

        return (
          <div key={modalityId} className="mb-4">
            {/* Modality Level - Checkbox */}
            <Form.Group className="form-check d-flex align-items-center gap-2 mb-2">
              <Form.Check
                type="checkbox"
                id={`folder-modality-${modalityId}`}
                label={
                  <span className="font_14 font-500 clr_blue mb-0">
                    {modalityData.modality}
                  </span>
                }
                checked={modalityData.selected}
                onChange={(e) =>
                  handleFolderModalityCheck(modalityId, e.target.checked)
                }
              />
            </Form.Group>

            {/* Sections Level - Only show if modality is selected */}
            {modalityData.selected && (
              <div className="ms-4">
                {!modalityData.sectionsLoaded && (
                  <div className="text-muted font_12 mb-2">
                    <i className="fas fa-spinner fa-spin me-2"></i>
                    Loading sections for {modalityData.modality}...
                  </div>
                )}

                {modalityData.sectionsLoaded &&
                  Object.keys(modalityData.sections).length === 0 ? (
                  <div className="text-muted font_12">
                    No sections available for {modalityData.modality}
                  </div>
                ) : (
                  Object.keys(modalityData.sections).map(sectionId => {
                    const sectionData = modalityData.sections[sectionId];

                    return (
                      <div
                        key={`folder-${modalityId}-${sectionId}`}
                        className="mb-3"
                      >
                        <Form.Group className="form-check d-flex align-items-center gap-2 mb-2">
                          <Form.Check
                            type="checkbox"
                            id={`folder-section-${modalityId}-${sectionId}`}
                            label={
                              <span className="font_14 font-500 clr_blue mb-0">
                                {sectionData.section_name}
                              </span>
                            }
                            checked={sectionData.selected}
                            onChange={(e) =>
                              handleFolderSectionCheck(
                                modalityId,
                                sectionId,
                                e.target.checked
                              )
                            }
                          />
                        </Form.Group>

                        {sectionData.selected && (
                          <div className="ms-4">
                            {!sectionData.bodyPartsLoaded && (
                              <div className="text-muted font_12 mb-2">
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Loading body parts...
                              </div>
                            )}

                            {sectionData.bodyPartsLoaded &&
                              Object.keys(sectionData.bodyParts).length ===
                              0 ? (
                              <div className="text-muted font_12">
                                No body parts available
                              </div>
                            ) : (
                              Object.keys(sectionData.bodyParts).map(
                                bodyPartId => {
                                  const bodyPartData =
                                    sectionData.bodyParts[bodyPartId];

                                  return (
                                    <Form.Group
                                      key={`folder-${modalityId}-${sectionId}-${bodyPartId}`}
                                      className="form-check mb-1"
                                    >
                                      <Form.Check
                                        type="checkbox"
                                        id={`folder-bodypart-${modalityId}-${sectionId}-${bodyPartId}`}
                                        label={
                                          <span className="font_12 clr_blue mb-0">
                                            {bodyPartData.body_part_name}
                                          </span>
                                        }
                                        checked={bodyPartData.selected}
                                        onChange={(e) =>
                                          handleFolderBodyPartCheck(
                                            modalityId,
                                            sectionId,
                                            bodyPartId,
                                            e.target.checked
                                          )
                                        }
                                      />
                                    </Form.Group>
                                  );
                                }
                              )
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  const TestCaseHierarchyComponent = () => (
    <div className="body_sec white_box rounded p-3">
      <h6 className="font_14 font-500 clr_blue mb-3">
        Select Sections and Body Parts
      </h6>

      {Object.keys(testCaseHierarchy).map(modalityId => {
        const modalityData = testCaseHierarchy[modalityId];

        return (
          <div key={modalityId} className="mb-4">
            {/* Modality Level - Checkbox */}
            <Form.Group className="form-check d-flex align-items-center gap-2 mb-2">
              <Form.Check
                type="checkbox"
                id={`testcase-modality-${modalityId}`}
                label={
                  <span className="font_14 font-500 clr_blue mb-0">
                    {modalityData.modality}
                  </span>
                }
                checked={modalityData.selected}
                onChange={(e) =>
                  handleTestCaseModalityCheck(modalityId, e.target.checked)
                }
              />
            </Form.Group>

            {/* Sections Level - Only show if modality is selected */}
            {modalityData.selected && (
              <div className="ms-4">
                {!modalityData.sectionsLoaded && (
                  <div className="text-muted font_12 mb-2">
                    <i className="fas fa-spinner fa-spin me-2"></i>
                    Loading sections for {modalityData.modality}...
                  </div>
                )}

                {modalityData.sectionsLoaded &&
                  Object.keys(modalityData.sections).length === 0 ? (
                  <div className="text-muted font_12">
                    No sections available for {modalityData.modality}
                  </div>
                ) : (
                  Object.keys(modalityData.sections).map(sectionId => {
                    const sectionData = modalityData.sections[sectionId];

                    return (
                      <div
                        key={`testcase-${modalityId}-${sectionId}`}
                        className="mb-3"
                      >
                        <Form.Group className="form-check d-flex align-items-center gap-2 mb-2">
                          <Form.Check
                            type="checkbox"
                            id={`testcase-section-${modalityId}-${sectionId}`}
                            label={
                              <span className="font_14 font-500 clr_blue mb-0">
                                {sectionData.section_name}
                              </span>
                            }
                            checked={sectionData.selected}
                            onChange={(e) =>
                              handleTestCaseSectionCheck(
                                modalityId,
                                sectionId,
                                e.target.checked
                              )
                            }
                          />
                        </Form.Group>

                        {sectionData.selected && (
                          <div className="ms-4">
                            {!sectionData.bodyPartsLoaded && (
                              <div className="text-muted font_12 mb-2">
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Loading body parts...
                              </div>
                            )}

                            {sectionData.bodyPartsLoaded &&
                              Object.keys(sectionData.bodyParts).length ===
                              0 ? (
                              <div className="text-muted font_12">
                                No body parts available
                              </div>
                            ) : (
                              Object.keys(sectionData.bodyParts).map(
                                bodyPartId => {
                                  const bodyPartData =
                                    sectionData.bodyParts[bodyPartId];

                                  return (
                                    <Form.Group
                                      key={`testcase-${modalityId}-${sectionId}-${bodyPartId}`}
                                      className="form-check mb-1"
                                    >
                                      <Form.Check
                                        type="checkbox"
                                        id={`testcase-bodypart-${modalityId}-${sectionId}-${bodyPartId}`}
                                        label={
                                          <span className="font_12 clr_blue mb-0">
                                            {bodyPartData.body_part_name}
                                          </span>
                                        }
                                        checked={bodyPartData.selected}
                                        onChange={(e) =>
                                          handleTestCaseBodyPartCheck(
                                            modalityId,
                                            sectionId,
                                            bodyPartId,
                                            e.target.checked
                                          )
                                        }
                                      />
                                    </Form.Group>
                                  );
                                }
                              )
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  // ================= Table Formatters =================
  const folderColumnFormatter = (cell, row) => {
    return (
      <div>
        <div
          className="d-flex align-items-center gap-2 folder-toggle"
          style={{ cursor: 'pointer' }}
          onClick={() => toggleFolder(row.folder_id)}
        >
          <span className="plus_mines">
            <i className={`fas ${expandedFolders[row.folder_id] ? 'fa-minus' : 'fa-plus'}`}></i>
          </span>
          <span className="file"><i className="fas fa-file"></i></span>
          <span className="fw-semibold">{row.folder_name}</span>
        </div>
        {expandedFolders[row.folder_id] && row.tests && (
          <div className="mt-2 ms-4">
            {row.tests.map((test) => (
              <div className="form-check mb-2" key={test.test_id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={(selectedTests[row.folder_id] || []).includes(test.test_id)}
                  onChange={(e) => handleTestSelection(row.folder_id, test.test_id, e.target.checked)}
                />
                <label className="form-check-label font_12 font-500 clr_blue">
                  {test.test_name}
                </label>
              </div>
            ))}
            <button
              className="btn btn-sm sky_theme mt-2"
              onClick={() => saveSelectedTests(row.folder_id)}
            >
              Save
            </button>
          </div>
        )}
      </div>
    );
  };

  const folderColumns = [
    {
      dataField: "folder_name",
      text: "Folder Name",
      formatter: folderColumnFormatter
    },
    {
      dataField: "created_at",
      text: "Creation Date",
      formatter: (cell) => formatDateTime(cell)
    },
    {
      dataField: "test_case_count",
      text: "Tests",
      formatter: (cell) => <span className="status running">{cell || 0} Tests</span>
    },
    {
      dataField: "is_active",
      text: "Status",
      formatter: (cell, row) => (
        <span className={`status ${cell ? 'completed' : 'failed'}`}>
          {cell ? 'Active' : 'Inactive'}
        </span>
      )
    },
    {
      dataField: "actions",
      text: "Action",
      formatter: (cell, row) => (
        <div
          className="d-flex align-items-center gap-3"
          style={{ whiteSpace: "nowrap" }}
        >
          {row.is_active ? (
            <>
              {/* View */}
              <Link
                to={`/admin/test-case-view/${row.folder_id}`}
                style={{ textDecoration: "none" }}
                className="clr_sky"
                title="View"
              >
                <SlEye size={22} />
              </Link>

              {/* Edit */}
              {/* <i
                className="fas fa-pencil-alt clr_grey"
                style={{ cursor: "pointer" }}
                title="Edit Folder"
                onClick={() => {
                  setIsEditMode(true);
                  setEditingFolderId(row.folder_id);
                  setNewFolder({
                    folder_name: row.folder_name,
                    description: row.description || "",
                  });
                  setShowFolderModal(true);
                }}
              ></i> */}

              {/* Delete */}
              <i
                className="fa fa-trash text-danger"
                style={{ cursor: "pointer" }}
                title="Delete Folder"
                onClick={() => deleteFolder(row.folder_id)}
              ></i>
            </>
          ) : (
            /* Restore */
            <i
              className="fas fa-redo text-success"
              style={{ cursor: "pointer" }}
              title="Restore Folder"
              onClick={() => restoreFolder(row.folder_id)}
            ></i>
          )}
        </div>
      ),
    }

  ];

  const testCaseColumns = [
    { dataField: "test_case_name", text: "Test Case Name" },
    { dataField: "folder_name", text: "Folder Name", formatter: (cell) => <span className="clr_grey">{cell}</span> },
    { dataField: "creation_date", text: "Creation Date", formatter: (cell) => <span className="clr_grey">{formatDateTime(cell)}</span> },
    { dataField: "status", text: "Status", formatter: (cell) => <span className={`status ${cell === 'active' ? 'completed' : 'failed'}`}> {cell || 'Inactive'}</span> },
    {
      dataField: "actions", text: "Action", formatter: (cell, row) => (
        <div className="text-end">
          <i
            className="fas fa-pencil-alt clr_grey me-2"
            style={{ cursor: "pointer" }}
          ></i>

          <i className="fa-solid fa-trash text-danger" style={{ cursor: 'pointer' }} onClick={() => deleteTestCase(row.test_case_id)}></i>
        </div>
      )
    }
  ];

  // ================= Effects =================
  useEffect(() => {
    fetchFolders(currentFolderPage);
    fetchTestCases(currentTestCasePage);
  }, [currentFolderPage, currentTestCasePage]);


  // ================= Test List Handlers =================
  const handleTestListModalityClick = (modalityName) => {
    setTestListSelectedModality(modalityName);

    // Later you can call API here if needed
    // fetchTestListByModality(modalityName);
  };


  useEffect(() => {
    setTestListHierarchy(initializeTestListHierarchy());
  }, []);


  const initializeTestListHierarchy = () => {
    const hierarchy = {};
    defaultModalityData.forEach((item) => {
      hierarchy[item.id] = {
        modality: item.modality,
        expanded: false,
        sections: {},
        sectionsLoaded: false
      };
    });
    return hierarchy;
  };

  const fetchTestListSections = async (modalityId, modalityName) => {
    try {
      setTestListLoading(true);

      const response = await APIServices.get(
        `admin/sections-by-modality?modality=${modalityName}`,
        headers
      );

      if (response?.status === 200) {
        const sectionsData = response.data || [];

        setTestListHierarchy(prev => {
          const updated = { ...prev };
          const sectionsObj = {};

          sectionsData.forEach(section => {
            sectionsObj[section.id] = {
              section_name: section.section_name,
              expanded: false,
              bodyParts: {},
              bodyPartsLoaded: false
            };
          });

          updated[modalityId] = {
            ...updated[modalityId],
            sections: sectionsObj,
            sectionsLoaded: true,
            expanded: true
          };

          return updated;
        });
      }
    } catch (error) {
      console.error("Test List: fetch sections error", error);
    } finally {
      setTestListLoading(false);
    }
  };


  const fetchTestListBodyParts = async (modalityId, sectionId, modalityName) => {
    try {
      const response = await APIServices.get(
        `admin/bodyparts-by-section?modality=${modalityName}&section_id=${sectionId}`,
        headers
      );

      if (response?.status === 200) {
        const bodyPartsData = response.data || [];

        setTestListHierarchy(prev => {
          const updated = { ...prev };
          const bodyPartsObj = {};

          bodyPartsData.forEach(bp => {
            bodyPartsObj[bp.id] = {
              body_part_name: bp.body_part_name
            };
          });

          updated[modalityId].sections[sectionId] = {
            ...updated[modalityId].sections[sectionId],
            bodyParts: bodyPartsObj,
            bodyPartsLoaded: true,
            expanded: true
          };

          return updated;
        });
      }
    } catch (error) {
      console.error("Test List: fetch body parts error", error);
    }
  };


  const handleTestListModalityToggle = (modalityId) => {
    setTestListHierarchy(prev => {
      const updated = { ...prev };
      const modality = updated[modalityId];
      const newExpandedState = !modality.expanded;

      if (newExpandedState) {
        // Expanding - keep sections if already loaded, otherwise fetch
        updated[modalityId] = {
          ...modality,
          expanded: true
        };

        if (!modality.sectionsLoaded) {
          fetchTestListSections(modalityId, modality.modality);
        }
      } else {
        // Collapsing - clear sections state
        updated[modalityId] = {
          ...modality,
          expanded: false,
          sections: {}, // Clear sections
          sectionsLoaded: false // Reset loaded flag
        };
      }

      return updated;
    });
  };

  const handleTestListSectionToggle = (modalityId, sectionId) => {
    setTestListHierarchy(prev => {
      const updated = { ...prev };
      const modality = updated[modalityId];
      const section = modality.sections[sectionId];

      if (!section) return prev;

      const newExpandedState = !section.expanded;

      if (newExpandedState) {
        // Expanding - keep body parts if already loaded, otherwise fetch
        updated[modalityId].sections[sectionId] = {
          ...section,
          expanded: true
        };

        if (!section.bodyPartsLoaded) {
          fetchTestListBodyParts(modalityId, sectionId, modality.modality);
        }
      } else {
        // Collapsing - clear body parts state
        updated[modalityId].sections[sectionId] = {
          ...section,
          expanded: false,
          bodyParts: {}, // Clear body parts
          bodyPartsLoaded: false // Reset loaded flag
        };
      }

      return updated;
    });
  };

  const TestListModalHierarchyComponent = () => {
    if (!selectedTestListModality) return null;

    const modalityId = selectedTestListModality.id;
    const modalityData = testListModalHierarchy[modalityId];

    if (!modalityData) {
      return (
        <div className="text-center p-4">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }

    return (
      <div className="body_sec white_box rounded p-3">

        {/* Modality Level - Already selected (no checkbox) */}
        <div className="mb-3 p-2 bg-light rounded">
          <div className="d-flex align-items-center gap-2">
            <i className="fas fa-check text-success"></i>
            <span className="font_14 font-500 clr_blue">
              {modalityData.modality} (Selected)
            </span>
          </div>
        </div>

        {/* Sections Level */}
        <div className="ms-4">
          {!modalityData.sectionsLoaded && (
            <div className="text-muted font_12 mb-2">
              <i className="fas fa-spinner fa-spin me-2"></i>
              Loading sections for {modalityData.modality}...
            </div>
          )}

          {modalityData.sectionsLoaded &&
            Object.keys(modalityData.sections).length === 0 ? (
            <div className="text-muted font_12">
              No sections available for {modalityData.modality}
            </div>
          ) : (
            Object.keys(modalityData.sections).map(sectionId => {
              const sectionData = modalityData.sections[sectionId];

              return (
                <div key={`modal-${modalityId}-${sectionId}`} className="mb-3">
                  {/* Section Checkbox */}
                  <Form.Group className="form-check d-flex align-items-center gap-2 mb-2">
                    <Form.Check
                      type="checkbox"
                      id={`modal-section-${modalityId}-${sectionId}`}
                      label={
                        <span className="font_14 font-500 clr_blue mb-0">
                          {sectionData.section_name}
                        </span>
                      }
                      checked={sectionData.selected}
                      onChange={(e) =>
                        handleTestListModalSectionCheck(
                          modalityId,
                          sectionId,
                          e.target.checked
                        )
                      }
                    />
                  </Form.Group>

                  {/* Body Parts - Show all (no checkboxes) */}
                  {sectionData.selected && (
                    <div className="ms-4">
                      {!sectionData.bodyPartsLoaded && (
                        <div className="text-muted font_12 mb-2">
                          <i className="fas fa-spinner fa-spin me-2"></i>
                          Loading body parts...
                        </div>
                      )}

                      {sectionData.bodyPartsLoaded &&
                        Object.keys(sectionData.bodyParts).length === 0 ? (
                        <div className="body-margin text-muted font_12">
                          No body parts available
                        </div>
                      ) : (
                        <div className="body-margin flex-wrap gap-2">
                          {Object.keys(sectionData.bodyParts).map(bodyPartId => {
                            const bodyPartData = sectionData.bodyParts[bodyPartId];
                            return (
                              <div
                                key={`modal-${modalityId}-${sectionId}-${bodyPartId}`}
                                className="bg-light rounded px-3 py-1 font_12 font-600"
                              ><i className="fas fa-check text-success"></i>
                                <spna className="body-margin-name">{bodyPartData.body_part_name}</spna>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    );
  };

  // Handler for clicking modality button
  const handleModalityButtonClick = (modality) => {
    setSelectedTestListModality(modality);
    setShowTestListModal(true);

    // Initialize hierarchy for this modality
    const initialHierarchy = {
      [modality.id]: {
        modality: modality.modality,
        sections: {},
        sectionsLoaded: false
      }
    };

    setTestListModalHierarchy(initialHierarchy);

    // Fetch sections for this modality
    fetchTestListModalSections(modality.id, modality.modality);
  };

  // Fetch sections for modal
  const fetchTestListModalSections = async (modalityId, modalityName) => {
    try {
      const response = await APIServices.get(
        `admin/sections-by-modality?modality=${modalityName}`,
        headers
      );

      if (response?.status === 200) {
        const sectionsData = response.data || [];

        setTestListModalHierarchy(prev => {
          const updated = { ...prev };
          const sectionsObj = {};

          sectionsData.forEach(section => {
            sectionsObj[section.id] = {
              section_name: section.section_name,
              selected: false, // Checkbox state
              bodyParts: {},
              bodyPartsLoaded: false
            };
          });

          updated[modalityId] = {
            ...updated[modalityId],
            sections: sectionsObj,
            sectionsLoaded: true
          };

          return updated;
        });
      }
    } catch (error) {
      console.error("Test List Modal: fetch sections error", error);
      setTestListModalHierarchy(prev => ({
        ...prev,
        [modalityId]: {
          ...prev[modalityId],
          sectionsLoaded: true
        }
      }));
    }
  };

  // Fetch body parts for modal section
  const fetchTestListModalBodyParts = async (modalityId, sectionId, modalityName) => {
    try {
      const response = await APIServices.get(
        `admin/bodyparts-by-section?modality=${modalityName}&section_id=${sectionId}`,
        headers
      );

      if (response?.status === 200) {
        const bodyPartsData = response.data || [];

        setTestListModalHierarchy(prev => {
          const updated = { ...prev };
          const bodyPartsObj = {};

          bodyPartsData.forEach(bp => {
            bodyPartsObj[bp.id] = {
              body_part_name: bp.body_part_name
            };
          });

          updated[modalityId].sections[sectionId] = {
            ...updated[modalityId].sections[sectionId],
            bodyParts: bodyPartsObj,
            bodyPartsLoaded: true
          };

          return updated;
        });
      }
    } catch (error) {
      console.error("Test List Modal: fetch body parts error", error);
      setTestListModalHierarchy(prev => {
        const updated = { ...prev };
        updated[modalityId].sections[sectionId] = {
          ...updated[modalityId].sections[sectionId],
          bodyPartsLoaded: true
        };
        return updated;
      });
    }
  };

  // Handle section checkbox in modal
  const handleTestListModalSectionCheck = async (modalityId, sectionId, checked) => {
    setTestListModalHierarchy(prev => {
      const updated = { ...prev };

      if (!updated[modalityId] || !updated[modalityId].sections[sectionId]) {
        return prev;
      }

      updated[modalityId].sections[sectionId] = {
        ...updated[modalityId].sections[sectionId],
        selected: checked
      };

      // Fetch body parts if checked and not loaded
      if (checked && !updated[modalityId].sections[sectionId].bodyPartsLoaded) {
        fetchTestListModalBodyParts(
          modalityId,
          sectionId,
          updated[modalityId].modality
        );
      }

      return updated;
    });
  };


  // ================= Render =================
  return (
    <>
      <div className="all_content test_run_management master_test_folder">
        <div className="container-fluid">
          {/* ================= TEST LIST SECTION ================= */}
          <div className="head-section mb-3">
            <h1 className="font_16 font-600 clr_blue">Master Test Cases</h1>
          </div>

          <div className="modality-buttons-container d-flex justify-content-end flex-wrap mb-2">
            {/* Add this button */}
            <div className="text-center mb-2" style={{ width: '14%' }}>
              <button
                className="btn btn-success btn-sm gap-2 w-100"
                onClick={() => setShowAllModalities(!showAllModalities)}
                style={{ padding: '10px 5px' }}
              >
                Total Test Case ({totalCount})
              </button>
            </div>


          </div>
          <div className=" d-flex align-items-center justify-content-between flex-wrap">
            {showAllModalities && (
              <>
                {defaultModalityData.map(modality => (
                  <div
                    key={`modality-${modality.id}`}
                    className="text-center mb-2"
                    style={{ width: '14%' }}
                  >
                    <button
                      className="btn sky_theme btn-sm gap-2 w-100 d-flex align-items-center justify-content-center"
                      onClick={() => handleModalityButtonClick(modality)}
                      style={{ padding: '10px 5px' }}
                      disabled={loadingModalityCounts}
                    >
                      <span>{modality.modality}</span>

                      {loadingModalityCounts ? (
                        <span className="ms-1">
                          <i className="fas fa-spinner fa-spin"></i>
                        </span>
                      ) : (
                        <span className="ms-1">
                          ({modalityCounts[modality.modality] || 0})
                        </span>
                      )}
                    </button>
                  </div>
                ))}
              </>
            )}
          </div>
          {/* ================= TEST LIST SECTION ================= */}
          {/* Master Test Folder Header */}
          <hr></hr>
          <div className="head-section d-flex align-items-center justify-content-between">
            <h1 className="font_16 font-600 clr_blue">Master Test Folder</h1>
            <div className="d-flex align-items-center gap-2">
              <button
                className="btn sky_theme btn-sm gap-2"
                onClick={() => {
                  setIsEditMode(false);
                  setEditingFolderId(null);
                  setNewFolder({ folder_name: "", description: "" });
                  setErrors({});
                  openFolderModal();
                }}
              >
                <i className="fa-solid fa-plus"></i> Add New Folder
              </button>

              <button className="btn sky_theme btn-sm gap-2" onClick={openTestCaseModal}>
                <i className="fa-solid fa-plus"></i> Add New Test Case
              </button>
            </div>

          </div>

          {/* Folder Table */}
          <div className="comman_table user_management_table mt-4">
            <div className="search-box d-flex align-items-center gap-3 p-3">
              <div className="search_input position-relative">
                <span className="search_icon"><i className="fa-solid fa-magnifying-glass"></i></span>
                <input
                  type="text"
                  className="form-control h-40"
                  placeholder="Search by folder name"
                  value={folderKeyword}
                  onChange={(e) => setFolderKeyword(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") fetchFolders(1); }}
                />
              </div>
              <div className="filter_select">
                <select
                  className="form-select h-40"
                  value={isActiveFilter.toString()}
                  onChange={(e) => {
                    const value = e.target.value === "true";
                    setIsActiveFilter(value);
                    setCurrentFolderPage(1);
                    fetchFolders(1, value);
                  }}
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
              <div className="btn_sec d-flex align-items-center gap-2">
                <button className="btn sky_theme btn-sm h-40" onClick={() => fetchFolders(1)}>Search</button>
                <button
                  className="btn d-flex align-items-center gap-2 font_14 clr_sky"
                  onClick={() => {
                    setFolderKeyword("");
                    setIsActiveFilter(true);
                    setCurrentFolderPage(1);
                    fetchFolders(1, true);
                  }}
                >
                  <i className="fas fa-redo-alt"></i> Reset
                </button>
              </div>
            </div>
            <div className="table-responsive">
              {loadingFolders ? <div className="text-center p-4"><div className="spinner-border spinner-border-sm" role="status"><span className="visually-hidden">Loading...</span></div></div> :
                <PaginatedTable
                  data={folders}
                  columns={folderColumns}
                  totalPages={totalFolderCount}
                  currentPage={currentFolderPage}
                  onPageChange={setCurrentFolderPage}
                  limit={folderLimit}
                  setLimit={setFolderLimit}
                  totalItems={folderPaginationData.total} // Use the state instead of response
                />
              }
            </div>
          </div>

        </div>
      </div>

      {/* ================= Modals ================= */}
      {/* Add Folder Modal */}
      {showFolderModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop show"
            onClick={() => {
              setShowFolderModal(false);
              setNewFolder({ folder_name: "", description: "" });
              setFolderHierarchy(initializeHierarchy());
            }}
          />

          {/* Modal - Keep your original structure but add width classes */}
          <div className="modal fade create_user comman_model show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '90%', width: '800px' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="font_16 font-500 clr_blue">
                    {isEditMode ? "Edit Test Folder" : "Add Test Folder"}
                  </h1>

                  <button type="button" className="btn-close" onClick={() => {
                    setShowFolderModal(false);
                    setNewFolder({ folder_name: "", description: "" });
                    setFolderHierarchy(initializeHierarchy());
                  }}></button>
                </div>
                <div className="modal-body modal-body-scroll">
                  <Form>
                    <Form.Group className="form-floating mb-4">
                      <Form.Control
                        type="text"
                        placeholder="Folder Name"
                        name="folder_name"
                        value={newFolder.folder_name}
                        onChange={handleFolderInputChange}
                        isInvalid={!!errors.folder_name}
                      />
                      <Form.Label>Folder Name *</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        {errors.folder_name}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* Sections and Body Parts Hierarchy */}
                    {!isEditMode && <FolderHierarchyComponent />}
                  </Form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-cancel sky_border" onClick={() => {
                    setShowFolderModal(false);
                    setNewFolder({ folder_name: "", description: "" });
                    setFolderHierarchy(initializeHierarchy());
                  }}>Cancel</button>
                  <button
                    className="btn sky_theme btn-sm"
                    onClick={isEditMode ? updateFolder : createFolder}
                  >
                    {isEditMode ? "Update" : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Add Test Case Modal */}
      {showTestCaseModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop show"
            onClick={() => {
              setShowTestCaseModal(false);
              setNewTestCase({ master_test_folder: "" });
              setTestCaseHierarchy(initializeHierarchy());
            }}
          />

          {/* Modal */}
          <div className="modal fade create_user comman_model show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '90%', width: '800px' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="font_16 font-500 clr_blue">Add Test Case</h1>
                  <button type="button" className="btn-close" onClick={() => {
                    setShowTestCaseModal(false);
                    setNewTestCase({ master_test_folder: "" });
                    setTestCaseHierarchy(initializeHierarchy());
                  }}></button>
                </div>
                <div className="modal-body modal-body-scroll">
                  <Form>
                    <Form.Group className="form-floating mb-4">
                      <Form.Select
                        style={{ paddingTop: 10 }}
                        name="master_test_folder"
                        value={newTestCase.master_test_folder}
                        onChange={handleTestCaseInputChange}
                      >
                        <option value="">Select Folder</option>
                        {allFolders.map(f => (
                          <option key={f.folder_id} value={f.folder_id}>
                            {f.folder_name} {f.test_case_count ? `(${f.test_case_count} tests)` : ''}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Label>Folder *</Form.Label>
                    </Form.Group>

            

                    {/* Test Case Hierarchy Section */}
                    <TestCaseHierarchyComponent />
                  </Form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-cancel sky_border" onClick={() => {
                    setShowTestCaseModal(false);
                    setNewTestCase({ master_test_folder: "" });
                    setTestCaseHierarchy(initializeHierarchy());
                  }}>Cancel</button>
                  <button className="btn sky_theme btn-sm" onClick={createTestCase}>
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Test List Modal */}
      {showTestListModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop show"
            onClick={() => {
              setShowTestListModal(false);
              setSelectedTestListModality(null);
              setTestListModalHierarchy({});
            }}
          />

          {/* Modal */}
          <div className="modal fade create_user comman_model show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '90%', width: '800px' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="font_16 font-500 clr_blue">
                    Test List - {selectedTestListModality?.modality || ''}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowTestListModal(false);
                      setSelectedTestListModality(null);
                      setTestListModalHierarchy({});
                    }}
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{
                    maxHeight: '70vh',
                    overflowY: 'auto'
                  }}
                >
                  <TestListModalHierarchyComponent />
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-cancel sky_border"
                    onClick={() => {
                      setShowTestListModal(false);
                      setSelectedTestListModality(null);
                      setTestListModalHierarchy({});
                    }}
                  >
                    Cancel
                  </button>

                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default MasterTestFolder;